import { Star } from "lucide-react";
import { Reveal } from "@/components/site/Reveal";
import { bookOnVrbo } from "@/lib/booking";
import { PROPERTY } from "@/data/property";

export function Reviews() {
  return (
    <section className="bg-primary text-primary-foreground py-20 md:py-28" data-testid="reviews-band">
      <div className="max-w-7xl mx-auto px-6 md:px-12 grid md:grid-cols-12 gap-10 items-center">
        <div className="md:col-span-4">
          <Reveal>
            <div className="flex items-end gap-3">
              <span className="font-display text-8xl md:text-9xl leading-none">{PROPERTY.rating}</span>
              <span className="font-display text-3xl text-primary-foreground/60 mb-3">/ 10</span>
            </div>
            <div className="mt-3 flex items-center gap-1">
              {[...Array(5)].map((_, i) => (
                <Star key={i} className="h-5 w-5 fill-accent text-accent" strokeWidth={1} />
              ))}
            </div>
          </Reveal>
        </div>

        <div className="md:col-span-5">
          <Reveal delay={0.05}>
            <h2 className="font-display text-3xl md:text-4xl leading-tight">
              Loved by <span className="italic">{PROPERTY.reviewCount}</span> guests and counting.
            </h2>
            <p className="mt-4 text-primary-foreground/75 font-light">
              A near-perfect rating across {PROPERTY.reviewCount} verified stays on VRBO — for the views, the space, and a host who makes it easy.
            </p>
          </Reveal>
        </div>

        <div className="md:col-span-3 md:text-right">
          <Reveal delay={0.1}>
            <button
              onClick={() => bookOnVrbo("reviews")}
              data-testid="reviews-book-button"
              className="inline-flex items-center gap-2 rounded-full bg-white px-7 py-3.5 text-sm font-medium text-primary transition-all duration-300 hover:gap-3 hover:bg-white/90"
            >
              Read reviews on VRBO
              <span aria-hidden>&rarr;</span>
            </button>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
